const quantityInput = document.getElementById('derfalllatzel-381275-anzahl') as HTMLInputElement | null;
const totalField = document.getElementById('derfalllatzel-381275-summe');
const priceInput = document.getElementById('derfalllatzel-381275-preis') as HTMLInputElement | null;
const shippingInput = document.getElementById('derfalllatzel-381275-porto') as HTMLInputElement | null;

if (quantityInput && totalField && priceInput && shippingInput) {
	const updateTotal = (): void => {
		const quantity = Math.max(0, Number.parseInt(quantityInput.value, 10) || 0);
		const price = Number.parseFloat(priceInput.value.replace(',', '.')) || 0;
		const shipping = Number.parseFloat(shippingInput.value.replace(',', '.')) || 0;
		const total = quantity * price + (quantity === 1 ? shipping : 0);
		const formattedTotal = total.toLocaleString('de-DE', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		});

		const totalText = totalField.querySelector('span');
		if (totalText) {
			totalText.textContent = `${formattedTotal} EUR`;
		}
	};

	quantityInput.addEventListener('input', updateTotal);
	quantityInput.addEventListener('change', updateTotal);
	updateTotal();
}